import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
    const { login, user } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);

    // Redirect already-authed admins into the dashboard.
    useEffect(() => {
        if (user) nav("/admin/dashboard", { replace: true });
    }, [user, nav]);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await login(email, password);
            toast.success("Welcome back, Admin.");
            nav("/admin/dashboard");
        } catch (err) {
            const msg = err?.response?.data?.detail || "Login failed";
            toast.error(typeof msg === "string" ? msg : "Login failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div data-testid="admin-login-page" className="pt-32 pb-24 mx-auto max-w-md px-6">
            <div className="rounded-[24px] border border-white/10 bg-white/[0.02] p-8">
                <div className="w-12 h-12 rounded-full bg-[#FFD400] text-black flex items-center justify-center mb-4">
                    <Lock className="w-5 h-5" />
                </div>
                <h1 className="font-display font-black text-3xl tracking-tight">Admin</h1>
                <p className="text-white/60 text-sm mt-1">Restricted area. Password required.</p>

                <form onSubmit={submit} className="mt-6 space-y-4">
                    <div>
                        <label className="text-xs uppercase tracking-widest text-white/50">Email</label>
                        <input
                            data-testid="admin-email"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-1 w-full bg-white/5 border border-white/10 rounded-[14px] px-4 py-3 text-white focus:border-[#FFD400] outline-none transition-colors"
                        />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-widest text-white/50">Password</label>
                        <input
                            data-testid="admin-password"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-1 w-full bg-white/5 border border-white/10 rounded-[14px] px-4 py-3 text-white focus:border-[#FFD400] outline-none transition-colors"
                        />
                    </div>
                    <button
                        data-testid="admin-login-btn"
                        type="submit"
                        disabled={busy}
                        className="w-full bg-[#FFD400] text-black font-bold rounded-full px-6 py-3.5 hover:scale-[1.02] transition-transform disabled:opacity-60"
                    >
                        {busy ? "Signing in…" : "Sign In"}
                    </button>
                </form>
            </div>
        </div>
    );
}
